import { EpStepContentCard } from './EpStepContentCard';
import { EpStepContentLabel } from './EpStepContentLabel';
import { EpStepContentRadio } from './EpStepContentRadio';

export const EpStepContent = {
  Card: EpStepContentCard,
  Label: EpStepContentLabel,
  Radio: EpStepContentRadio,
};
